<template>
  <span>
    <InputFile
      accept=".csv,.txt"
      :file-name="fileName"
      @change="loadTextFromFile"
    />
    <div
      v-t="'FILE_MAXIMUM_SIZE'"
      class="text-muted"
    />
    <modal
      v-model="openModal"
      :title="$i18n.t('FILE_TOO_BIG_ERROR_TITLE')"
    >
      <p v-t="'FILE_TOO_BIG_ERROR'" />
      <div slot="footer">
        <btn
          v-t="'CANCEL'"
          @click="openModal=false"
        />
      </div>
    </modal>
  </span>
</template>

<script>
import InputFile from '@/core/components/Form/InputFile';
import sharedMessages from '@/core/locales';
import messages from '../../locales';

export default {
  components: { InputFile },
  props: {
    fileName: {
      type: String,
      default() {
        return '';
      },
    }
  },
  data() {
    return {
      openModal: false,
    };
  },
  methods: {
    loadTextFromFile(file) {
      if(file.size < 1048576){
        const reader = new FileReader();
        reader.onload = e => this.$emit('load', {result: e.target.result, fileName: file.name});
        reader.readAsText(file);
      } else {
        this.openModal = true;
      }
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
</style>